module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller-details/telecaller-details.component.css
// module id = ./src/app/prospect/telecaller-details/telecaller-details.component.css
// module chunks = main